import React from "react";
import {Box, Grid, Typography} from "@mui/material";

import "./privacySafety.css";

const PrivacySafety = () => {
  return (
    <Box className="privacyMain">
      <Typography variant="h4" className="setting_page_heading">
        Privacy & Safety
      </Typography>

      <Typography variant="h6">
        Terms of Service & Privacy Policy
        <br/>
      </Typography>

      <Box className="privacyInfo" mb={4}>
        <Typography mb={3}>
          PRIVACY POLICY FOR buythedip.com. This privacy notice discloses the privacy practices for www.buythedip.com. This privacy notice applies solely to information collected by this website.
        </Typography>
        
        <Typography variant="h6">
          1. INFORMATION COLLECTION, USE, AND SHARING
        </Typography>
        
        <Typography mb={3}>
          We are the sole owners of the information collected on this site. We only have access to collect information that you voluntarily give us via email, user registration or other direct contacts from you. We will not sell, rent, share or distribute this information to anyone. 
          Your information could be used to respond to you, regarding the reason you contacted us or to send updates like upcoming payments or events, service notifications, etc. We will not share your information with any third party outside of our organization.
        </Typography>

        <Typography variant="h6">
          2. YOUR ACCESS TO AND CONTROL OVER INFORMATION
        </Typography>
        
        <Typography mb={3}>
          You may opt out of any future contacts from us at any time. You can achieve this through the unsubscribe link featured in our emails or by contacting us via the email address or phone number given on our website. 
          Upon request, we offer the following actions for users: View what data we have about you if any. 
          Change or correct any data we have about you. Delete any data we have about you. Express any concern you have about our use of your data.
        </Typography>

        <Typography variant="h6">
          3. DATA SECURITY
        </Typography>
        
        <Typography mb={3}>
          We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline. 
          Only employees or trusted affiliates who need the information to perform a specific job (for example, billing or customer service) are granted access to personally identifiable information. 
          Please note that no method of transmission over the internet or method of electronic storage, is 100% secure. 
          Therefore, while we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.
        </Typography>
        
        <Typography variant="h6">
          4. UPDATES
        </Typography>

        <Typography mb={3}>
          Our Privacy Policy may change from time to time and all updates will be posted on this page.
        </Typography>
        
        <Typography variant="h6">
          5. CONTACT US
        </Typography>

        <Typography mb={3}>
          If you feel that we are not abiding by this privacy policy, you should contact us immediately via email at hi@buythedip.com or via our website buythedip.com. This privacy policy was last updated on April 1st, 2020 and is subject to change.
        </Typography>
      </Box>
    </Box>
  );
};

export default PrivacySafety;
